import React, { useState } from 'react'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'
import Collapse from '@mui/material/Collapse'
import { Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DOMPurify from 'dompurify'
import { TabContext, TabPanel } from '@mui/lab'
import Box from '@mui/material/Box'
import TabList from '@mui/lab/TabList'
import Tab from '@mui/material/Tab'

interface Props {
  description: string | null
}

const ProductDescription: React.FC<Props> = ({ description }) => {
  const { t } = useTranslation()

  const [value, setValue] = React.useState('1')

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  const descriptionSanitized = DOMPurify.sanitize(description || '')
  const regExp = /\+\+\+[\s]*[^+]*[\S]*\+\+\+/gm
  const descriptionTitles = descriptionSanitized.match(regExp)
    ? descriptionSanitized.match(regExp).filter(val => !!val)
    : []
  const descriptionGroups = descriptionSanitized.split(regExp).filter((val: string) => !!val)
  if (descriptionGroups.length !== descriptionTitles.length) {
    descriptionTitles.unshift(t('productDetails', 'Product Details'))
  }
  if (descriptionGroups.length === 0) {
    return null
  }
  return (
    <section className='py:20 md:pt-80 mx-auto max-w-lg'>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label='Product description tabs' variant='scrollable' scrollButtons>
            {descriptionGroups.map((html: string, idx: number) => {
              const title = descriptionTitles[idx]
                ? descriptionTitles[idx].replace(/\+{3}/gm, '').trim()
                : t('productDetails', 'Product Details')

              return (
                <Tab
                  key={idx}
                  classes={{ root: '!max-w-full' }}
                  disableRipple
                  label={
                    <span
                      className='text-xl md:text-2xl font-medium hover:text-black'
                      dangerouslySetInnerHTML={{ __html: title }}
                    />
                  }
                  value={String(idx + 1)}
                />
              )
            })}
          </TabList>
        </Box>
        {descriptionGroups.map((html: string, idx: number) => {
          return (
            <TabPanel value={String(idx + 1)} key={idx} classes={{ root: '!px-0' }}>
              <div className='pt-10 text-lg break-words'>
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </div>
            </TabPanel>
          )
        })}
      </TabContext>
    </section>
  )
}

export default ProductDescription
